import PropTypes from 'prop-types'

/**
 * @typedef {Object} Setting
 * @property {string} [name]
 * @property {string} [type]
 * @property {Array<string>} [values]
 */
export const settingPropType = PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    values: PropTypes.arrayOf(PropTypes.string)
})
